"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = handleChange;
function handleChange(_ref) {
  let {
    e,
    value,
    name
  } = _ref;
  const component = this,
    props = this.props,
    state = this.state;
  if (e === null) return;
  let status_messages = state.status_messages;
  delete status_messages[name];
  component.setState({
    [name]: value,
    info: undefined,
    error: undefined,
    warning: undefined,
    status_messages: status_messages
  });
}
